import React, { ReactElement } from 'react';

interface Props {
  width?: string;
  height?: string;
}

const Calendar = (props: Props): ReactElement => {
  const { width, height } = props;

  return (
    <svg width={width} height={height} viewBox="0 0 14 14">
      <path d="M12.834 1.313h-1.896V.438a.437.437 0 1 0-.876 0v.875H7.438V.438a.437.437 0 1 0-.875 0v.875H3.938V.438a.437.437 0 1 0-.876 0v.875H1.167C.522 1.313 0 1.833 0 2.478v10.354C0 13.478.522 14 1.167 14h11.667c.644 0 1.166-.522 1.166-1.167V2.48c0-.645-.522-1.167-1.166-1.167zm.291 11.52c0 .161-.13.292-.291.292H1.167a.292.292 0 0 1-.292-.292V2.48c0-.16.13-.292.292-.292h1.895v.876a.437.437 0 1 0 .876 0v-.876h2.624v.876a.437.437 0 1 0 .875 0v-.876h2.625v.876a.437.437 0 1 0 .876 0v-.876h1.896c.16 0 .291.131.291.292v10.354z" />
      <path d="M2.925 5.015h1.672v1.253H2.925zM2.925 7.404h1.672v1.254H2.925zM2.925 9.793h1.672v1.254H2.925zM6.15 9.793h1.672v1.254H6.15zM6.15 7.404h1.672v1.254H6.15zM6.15 5.015h1.672v1.253H6.15zM9.276 9.793h1.671v1.254H9.276zM9.276 7.404h1.671v1.254H9.276zM9.276 5.015h1.671v1.253H9.276z" />
    </svg>
  );
};

Calendar.defaultProps = {
  width: '100%',
  height: '100%',
};

export default Calendar;
